import minutesToHours from 'date-fns/minutesToHours';
import translate from '@/lib/intl/translate';

/**
 * formats donation time
 * @param {number} value - a numeric value
 * @return {string} - formatted donation time
 */
export const formatDonationTime = (value) => {
  if (value >= 1 && value <= 59) {
    return translate('LESS_THAN_1_HOUR');
  }

  return translate('X_HOURS', { hours: minutesToHours(value) });
};
